export default {
    font: {
        family: '"Montserrat", "Helvetica", "Arial", sans-serif'
    },
    palette: {
        common: {
            black: "#000000",
            white: "#FFFFFF"
        },
        primary: {
            100: {
                value: "#eef6fa",
                contrastValue: "#004066"
            },
            200: {
                value: "#bddbeb",
                contrastValue: "#004066"
            },
            300: {
                value: "#8dc0dc",
                contrastValue: "#004066"
            },
            400: {
                value: "#5da5cd",
                contrastValue: "#fff"
            },
            500: {
                value: "#2d8abd",
                contrastValue: "#fff"
            },
            600: {
                value: "#177ab0",
                contrastValue: "#fff"
            },
            700: {
                value: "#06689e",
                contrastValue: "#fff"
            },
            800: {
                value: "#005586",
                contrastValue: "#fff"
            },
            900: {
                value: "#004066",
                contrastValue: "#fff"
            }
        },
        secondary: {
            100: {
                value: "#ecfaf7",
                contrastValue: "#006652"
            },
            200: {
                value: "#b7ebe1",
                contrastValue: "#006652"
            },
            300: {
                value: "#82dcca",
                contrastValue: "#006652"
            },
            400: {
                value: "#4eccb3",
                contrastValue: "#fff"
            },
            500: {
                value: "#1abc9c",
                contrastValue: "#fff"
            },
            600: {
                value: "#05b18f",
                contrastValue: "#fff"
            },
            700: {
                value: "#00a07e",
                contrastValue: "#fff"
            },
            800: {
                value: "#00896a",
                contrastValue: "#fff"
            },
            900: {
                value: "#006652",
                contrastValue: "#fff"
            }
        },
        gray: {
            100: {
                value: "#f4f5f7",
                contrastValue: "#677185"
            },
            200: {
                value: "#dcdfe6",
                contrastValue: "#23272e"
            },
            300: {
                value: "#c8ccd4",
                contrastValue: "#23272e"
            },
            400: {
                value: "#9098a9",
                contrastValue: "#23272e"
            },
            500: {
                value: "#6e798e",
                contrastValue: "#fff"
            },
            600: {
                value: "#505c77",
                contrastValue: "#fff"
            },
            700: {
                value: "#3e4b69",
                contrastValue: "#fff"
            },
            800: {
                value: "#2f3e5e",
                contrastValue: "#fff"
            },
            900: {
                value: "#223254",
                contrastValue: "#fff"
            },
            1000: {
                value: "#d8dcde",
                contrastValue: "#677185"
            }
        },
        blue: {
            100: {
                value: "#eef6fa",
                contrastValue: "#004066"
            },
            200: {
                value: "#bddbeb",
                contrastValue: "#004066"
            },
            300: {
                value: "#8dc0dc",
                contrastValue: "#004066"
            },
            400: {
                value: "#5da5cd",
                contrastValue: "#fff"
            },
            500: {
                value: "#2d8abd",
                contrastValue: "#fff"
            },
            600: {
                value: "#177ab0",
                contrastValue: "#fff"
            },
            700: {
                value: "#06689e",
                contrastValue: "#fff"
            },
            800: {
                value: "#005586",
                contrastValue: "#fff"
            },
            900: {
                value: "#004066",
                contrastValue: "#fff"
            }
        },
        green: {
            100: {
                value: "#ecfaf7",
                contrastValue: "#006652"
            },
            200: {
                value: "#b7ebe1",
                contrastValue: "#006652"
            },
            300: {
                value: "#82dcca",
                contrastValue: "#006652"
            },
            400: {
                value: "#4eccb3",
                contrastValue: "#fff"
            },
            500: {
                value: "#1abc9c",
                contrastValue: "#fff"
            },
            600: {
                value: "#05b18f",
                contrastValue: "#fff"
            },
            700: {
                value: "#00a07e",
                contrastValue: "#fff"
            },
            800: {
                value: "#00896a",
                contrastValue: "#fff"
            },
            900: {
                value: "#006652",
                contrastValue: "#fff"
            }
        },
        red: {
            100: {
                value: "#ffe6e8",
                contrastValue: "#4d0019"
            },
            200: {
                value: "#ffacb5",
                contrastValue: "#4d0019"
            },
            300: {
                value: "#fc7386",
                contrastValue: "#4d0019"
            },
            400: {
                value: "#f23c5a",
                contrastValue: "#fff"
            },
            500: {
                value: "#e40e31",
                contrastValue: "#fff"
            },
            600: {
                value: "#c30528",
                contrastValue: "#fff"
            },
            700: {
                value: "#a60023",
                contrastValue: "#fff"
            },
            800: {
                value: "#79001f",
                contrastValue: "#fff"
            },
            900: {
                value: "#4d0019",
                contrastValue: "#fff"
            }
        },
        yellow: {
            100: {
                value: "#fffae6",
                contrastValue: "#b33e00"
            },
            200: {
                value: "#ffeeac",
                contrastValue: "#b33e00"
            },
            300: {
                value: "#ffde73",
                contrastValue: "#b33e00"
            },
            400: {
                value: "#ffcd39",
                contrastValue: "#b33e00"
            },
            500: {
                value: "#ffb907",
                contrastValue: "#fff"
            },
            600: {
                value: "#ec9c00",
                contrastValue: "#fff"
            },
            700: {
                value: "#d97d00",
                contrastValue: "#fff"
            },
            800: {
                value: "#c65d00",
                contrastValue: "#fff"
            },
            900: {
                value: "#b33e00",
                contrastValue: "#fff"
            }
        },
        orange: {
            100: {
                value: "#fffae6",
                contrastValue: "#b33e00"
            },
            200: {
                value: "#ffeeac",
                contrastValue: "#b33e00"
            },
            300: {
                value: "#ffde73",
                contrastValue: "#b33e00"
            },
            400: {
                value: "#ffcd39",
                contrastValue: "#b33e00"
            },
            500: {
                value: "#ffb907",
                contrastValue: "#fff"
            },
            600: {
                value: "#ec9c00",
                contrastValue: "#fff"
            },
            700: {
                value: "#d97d00",
                contrastValue: "#fff"
            },
            800: {
                value: "#c65d00",
                contrastValue: "#fff"
            },
            900: {
                value: "#b33e00",
                contrastValue: "#fff"
            }
        }
    },
    shadows: {
        base: "none",
        100: "0 2px 4px 0 rgba(34, 50, 84, 0.1)",
        200: "0 4px 8px 0 rgba(34, 50, 84, 0.1)",
        300: "0 8px 20px 0 rgba(34, 50, 84, 0.2)"
    }
};
